var map = {
	"./2026-27-topps-flagship-basketball-budget-guide.json": 7546,
	"./2026-bowman-chrome-baseball-budget-guide.json": 2465,
	"./2026-topps-heritage-football-budget-guide.json": 7375,
	"./2026-topps-holiday-baseball-budget-guide.json": 4587,
	"./2026-topps-update-series-baseball-budget-guide.json": 3054,
	"./buy-sports-card-bulk-lots-budget-guide.json": 1339,
	"./complete-sports-card-set-on-ebay-budget.json": 8268,
	"./ebay-bundle-discounts-sports-cards.json": 9972,
	"./ebay-standard-envelope-sports-cards-packing-guide.json": 2478,
	"./how-to-store-raw-sports-cards.json": 8408,
	"./november-2026-sports-card-releases-budget-guide.json": 5197,
	"./october-2026-sports-card-releases-budget-guide.json": 493,
	"./photograph-raw-sports-cards-ebay.json": 2570,
	"./price-low-end-sports-cards-ebay.json": 8573,
	"./raw-sports-card-condition-guide.json": 4517,
	"./sell-low-end-sports-cards-singles-lots-sets.json": 3515,
	"./smarter-way-to-collect-data-driven-insights.json": 1966,
	"./sports-card-parallels-vs-inserts-guide.json": 1060,
	"./the-national-2025-why-every-collector-should-be-watching.json": 8988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5392;